var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowWTextSe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 342 342",
    style: {
      enableBackground: "new 0 0 342 342"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:50;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#424241;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_arrow"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177,44.6c37,1.8,72.9,19.9,96.1,52.3c40.3,56.4,27.4,134.8-29,175.2s-134.8,27.4-175.2-29 C47.1,212.8,40.8,176,48.6,142.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "84.1,172.2 76.3,87.7 7.1,136.7  "
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lager_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.3,172.9l0.5,4.9c0.3,2.9-1.3,3.3-3,3.4l-13.6,1.3c-2.7,0.3-3.6-0.4-3.8-2.6l-0.5-5.2L110.3,172.9z  M108.1,175.8l-15.4,1.5l0.2,1.8c0.1,0.8,0.5,0.8,1.2,0.8l12.9-1.2c0.8-0.1,1.4-0.2,1.3-1.2L108.1,175.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.8,191l-19.5,6.3l-0.8-2.5l19.5-6.3L113.8,191z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.9,201.1c1.5-0.9,2.6-1.5,3.9-1.4c1.8,0,2.7,1.3,3.2,2.1c1.9,3.2-0.7,4.7-2,5.4l-1.9,1.1l-1.3-2.2l2-1.2 c1-0.6,1.8-1.1,1.2-2.1c-0.7-1.2-1.8-0.5-2.6,0l-10.2,6c-1.2,0.7-2.1,1.2-1.4,2.4s1.7,0.6,2.3,0.2l4-2.4l-0.8-1.4l2.2-1.3 l2.2,3.7l-9.4,5.5l-0.8-1.4l0.7-0.7c-0.6-0.1-1.6-0.2-2.4-1.5c-1.9-3.2,1.2-5,2.5-5.8L111.9,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.7,213.4l-15,14l-1.8-1.9l15-14L127.7,213.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.2,217.8l7.4,5.3l-1.4,2l-2.6-1.9L125,237.8l-2.2-1.6l10.5-14.7l-2.5-1.8L132.2,217.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149.2,227.6l-5,20.1l-2.4-1l1-3.7l-2.8-1.2l-1.9,3.3l-2.4-1l10.5-17.8L149.2,227.6z M146.1,230.5 c-1.1,2.4-1.2,2.7-1.4,3l-3.5,6.2l2.3,0.9l1.8-7c0.2-0.8,0.5-1.5,1.1-3.1L146.1,230.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.2,230.8l-2.8,17.8l4.4,0.7l-0.4,2.5l-7.1-1.1l3.2-20.3L161.2,230.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.9,231.6l0.8,20.5l-2.7,0.1l-0.8-20.5L174.9,231.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189,246.3c0.2,0.7,0.5,1.9,1.8,1.6c1.2-0.3,0.9-1.6,0.7-2.6c-0.5-1.9-1-2.6-3.5-4.8 c-2.2-1.9-3.7-3.3-4.4-5.8c-0.3-1.1-0.3-2,0-2.9c0.5-1.5,1.6-2.1,2.9-2.5c2.5-0.6,3.7,0.5,4.2,2.5l0.9,3.5l-2.4,0.6l-0.9-3.5 c-0.2-0.6-0.4-1.3-1.4-1.1c-1.2,0.3-1.1,1.4-0.8,2.3c0.5,2,1.4,2.8,4,5.1c1.7,1.6,3.3,2.9,3.9,5.4c0.3,1.3,0.3,2.7-0.1,3.6 c-0.6,1.5-1.9,1.9-2.6,2.1c-3.8,1-4.6-2.3-4.9-3.3l-0.9-3.3l2.4-0.6L189,246.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197,225.9l6-3.2l1.2,2.3l-3.5,1.9l2.8,5.3l3.2-1.7l1.2,2.2l-3.2,1.7l3.2,6l3.6-1.9l1.2,2.3l-6,3.2 L197,225.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M209,218.5l3.3-3c2.4-2.2,3.3-1.8,6.1,1.2c2.4,2.7,3.4,3.8,1.7,5.3l0.1,0.1c1.6-1.1,2.5-0.5,4.4,1.5l1.5,1.7 c1.7,1.8,2,2.1,3.1,2.6l-2.1,1.9c-1-0.7-1.8-1.3-3.2-2.9l-1-1.1c-0.5-0.6-1.6-1.8-2.3-2c-0.6-0.2-0.9,0-2.1,1.1l6.4,7l-2,1.8 L209,218.5z M212.7,218.5l4.3,4.7l0.9-0.9c1-0.9,0.6-1.4-1.6-3.9c-1.5-1.7-1.7-1.6-2.5-0.8L212.7,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M221.4,204.9l16.7,11.8l-1.5,2.2l-16.7-11.8L221.4,204.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M226.7,195.2l13.3,2.2c0.8,0.1,1.4,0.2,2,0.4l0.1-0.2c-0.9-0.3-1.9-0.5-2.8-0.8l-1.8-0.6l-9.6-3.8l1-2.3 l18.9,7.8l-1.1,2.8l-15.5-2.7l-0.1,0.2l1.7,0.5l1.7,0.6l11,4.3l-1,2.3l-18.9-7.8L226.7,195.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M236.3,183.4c-1.8-0.2-2.9-0.4-4-1.3c-1.4-1.1-1.4-2.7-1.2-3.6c0.5-3.6,3.4-3.2,4.9-3.1l2.1,0.3l-0.3,2.5 l-2.3-0.3c-1.2-0.1-2.1-0.2-2.2,1c-0.2,1.4,1.1,1.5,2.1,1.6l11.7,1.5c1.3,0.2,2.4,0.3,2.6-1c0.2-1.4-1-1.5-1.6-1.6l-4.6-0.6 l-0.2,1.6l-2.5-0.3l0.5-4.3l10.8,1.4l-0.2,1.6l-1,0.1c0.4,0.4,1.1,1.1,1,2.6c-0.5,3.7-4.1,3.2-5.5,3L236.3,183.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.3,137.5l18.8,8.2l-1.1,2.4l-18.8-8.2L97.3,137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.6,123.3l12.3,5.5c0.7,0.3,1.3,0.6,1.9,0.9l0.1-0.1c-0.8-0.5-1.7-1-2.5-1.5l-1.6-1.1l-8.3-6.1l1.5-2 l16.3,12.4l-1.8,2.4l-14.3-6.6l-0.1,0.1l1.5,1l1.5,1l9.6,6.9l-1.5,2l-16.3-12.4L105.6,123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.5,106.9l10.3,8.7c0.6,0.5,1,0.9,1.6,1.4l0.1-0.1c-0.7-0.7-1.3-1.4-2-2.2l-1.2-1.5L124,105l2-1.5 l12.3,16.4l-2.4,1.8L124,111.5l-0.1,0.1l1.2,1.3l1.2,1.3l7.3,9.3l-2,1.5l-12.3-16.4L121.5,106.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.1,102c-0.7-1.7-1.1-3-0.6-4.3c0.4-1.2,1.4-2.1,2.6-2.5c1.1-0.4,2.2-0.6,3.3,0c1.5,0.7,2,2,2.9,4.4 l3.5,9.1c0.5,1.4,1.7,4.5-2.5,6.1c-0.5,0.2-2.5,0.9-4.1-0.6c-0.8-0.7-1.1-1.6-1.5-2.5L140.1,102z M145.6,99.7 c-0.6-1.7-1.1-2.9-2.6-2.4c-0.2,0.1-1.1,0.4-1.1,1.5c0,0.4,0.2,0.8,0.6,2l3.9,10.3c0.4,0.9,0.8,2,2.2,1.4 c1.5-0.6,1.1-1.8,0.6-3.2L145.6,99.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.8,90.1l2.7-0.2l-1.3,20.7l-3.1,0.3l-5-20.1l2.7-0.2l2.6,11.6c0.5,2.3,0.6,2.5,0.8,4.5h0.3 c-0.1-1.9-0.1-2,0-4.8L165.8,90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.7,91.3l-0.2,20.7l-2.6-0.4l0.1-3.8l-3-0.5l-1.1,3.6l-2.6-0.4l6.1-19.8L185.7,91.3z M183.3,94.8 c-0.5,2.6-0.6,2.9-0.7,3.2l-2,6.8l2.4,0.4l0.1-7.2c0-0.8,0.1-1.6,0.4-3.2L183.3,94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M198.4,94.6l8.3,3.5l-0.9,2.2l-2.9-1.2l-7,16.7l-2.5-1.1l7-16.7l-2.9-1.2L198.4,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.4,105.2L206.7,122l-2.2-1.5l11.7-16.8L218.4,105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M224.3,117.3c1.4-1.2,2.4-2.1,3.8-2.1c1.3,0,2.5,0.6,3.3,1.6c0.8,0.8,1.3,1.8,1.2,3.1 c-0.1,1.6-1.2,2.6-3.1,4.3l-7.2,6.5c-1.1,1-3.6,3.2-6.6-0.1c-0.4-0.4-1.8-2-0.9-4c0.4-1,1.1-1.6,1.8-2.3L224.3,117.3z  M228.4,121.6c1.3-1.2,2.3-2.1,1.3-3.3c-0.1-0.2-0.8-0.9-1.7-0.5c-0.4,0.2-0.7,0.5-1.7,1.3l-8.2,7.4c-0.8,0.7-1.5,1.5-0.5,2.6 c1.1,1.2,2.1,0.3,3.2-0.6L228.4,121.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M243.2,134.2l-10.4,8.5c-0.6,0.5-1.1,0.9-1.6,1.3l0.1,0.2c0.8-0.5,1.6-1.1,2.5-1.5l1.7-0.9l9.2-4.7l1.1,2.3 l-18.4,9l-1.3-2.7l12.3-9.8l-0.1-0.2l-1.5,0.9l-1.5,0.9l-10.5,5.4l-1.1-2.3l18.4-9L243.2,134.2z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWTextSe);
export default __webpack_public_path__ + "static/media/arrow_w_text_SE.586a25802d26fd31bbbfcf67548f7b54.svg";
export { ForwardRef as ReactComponent };